import { toRaw } from "vue";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";

const clone = (value) => cloneDeep(toRaw(value));

export const createChangeTracker = (initial = {}) => {
  let base = clone(initial);
  const sent = new Map();

  const referenceOf = (key, currentBase) => {
    const entry = sent.get(key);
    return entry && isEqual(entry.base, currentBase?.[key])
      ? entry.value
      : currentBase?.[key];
  };

  return {
    changes(form, { fields, base: currentBase = base } = {}) {
      const values = toRaw(form);
      return Object.fromEntries(
        (fields ?? Object.keys(values))
          .filter(
            (key) =>
              key in values &&
              !isEqual(toRaw(values[key]), referenceOf(key, currentBase))
          )
          .map((key) => [key, clone(values[key])])
      );
    },

    commit(changes, currentBase = base) {
      for (const [key, value] of Object.entries(changes)) {
        sent.set(key, { value: clone(value), base: clone(currentBase?.[key]) });
      }
    },

    reset(value = {}) {
      base = clone(value);
      sent.clear();
    },
  };
};
